/** Chaînes françaises pour la tranche expert (namespace : expert.*). */
export const expertFr = {
  title: "Répertoire d'experts",
  subtitle:
    "Experts en développement durable validés pour cette action du plan d'action.",
  loading: "Chargement…",
  error: "Une erreur est survenue.",
  retry: "Réessayer",

  tabs: {
    directory: "Répertoire",
    favorites: "Favoris",
    register: "Inscription",
    dashboard: "Mon profil",
  },

  orgTypes: {
    self_employed: "Travailleur autonome",
    private: "Entreprise privée",
    cooperative: "Coopérative et entreprise collective",
    not_for_profit: "Organisme à but non lucratif",
    economical_development: "Organisme de développement économique",
    municipality: "Municipalité",
    other: "Autre",
  },

  serviceTypes: {
    analysis: "Analyse, étude (de marché, de faisabilité), diagnostic",
    coaching: "Accompagnement et services-conseils (coaching, mentorat)",
    strategic_planning: "Planification stratégique, plan d'action, concertation",
    business_startup: "Création, implantation et démarrage d'entreprises",
    infrastructure:
      "Infrastructures (mise aux normes, agrandissement, rénovation, construction)",
    technology_adoption: "Acquisition et implantation d'une technologie",
    commercialization: "Commercialisation d'un produit ou d'une technologie",
    market_development: "Expansion et développement des marchés",
    technology_demo:
      "Démonstration, vitrine technologique, projets de maturation technologique",
    certification: "Homologation ou certification",
    audit: "Audit et vérification",
    investment_support: "Appui aux projets d'investissement",
    research_development: "Recherche et développement, innovation",
    training: "Développement d'outils, formation et sensibilisation",
    turnaround: "Redressement et rétention d'entreprises stratégiques",
    hiring_support: "Soutien financier pour l'embauche de professionnels",
    other: "Autre (veuillez préciser)",
  },

  directory: {
    heading: "Répertoire d'experts",
    help: "Experts validés pouvant vous accompagner pour cette action du plan d'action, classés selon leur pertinence pour votre entreprise.",
    resultCount_one: "{{count}} expert trouvé",
    resultCount_other: "{{count}} experts trouvés",
    favoriteCount_one: "{{count}} expert favori",
    favoriteCount_other: "{{count}} experts favoris",
    tierNavLabel: "Catégories de pertinence",
    bestMatch: "Meilleure correspondance",
    seeMore_one: "Voir {{count}} expert de plus",
    seeMore_other: "Voir {{count}} experts de plus",
    none: "Aucun expert n'est disponible pour cette action pour le moment.",
    noFavorites: "Vous n'avez pas encore d'expert favori pour cette action.",
    seeAll: "Voir tous les experts",
    unavailable: "Le répertoire d'experts n'est pas offert pour cette action.",
    disabled: "Le répertoire d'experts n'est pas offert avec votre compte.",
    actionRequired: {
      title: "Ouvrez le répertoire depuis une action",
      help: "Le répertoire d'experts s'ouvre à partir d'une action de votre plan d'action. Rendez-vous dans vos plans d'action et cliquez sur « Trouver des experts » sous une action admissible.",
      goToPlans: "Aller aux plans d'action",
    },
  },

  filters: {
    // Two strings, as the Django rail has: « Filtrer » heads the open rail
    // (_filters.html) and « Filtres » labels the panel disclosure that opens
    // it (_panel_content.html).
    heading: "Filtrer",
    panelToggle: "Filtres",
    search: "Nom, organisation…",
    searchLabel: "Rechercher un expert",
    originRegions: "Régions d'origine",
    serviceTypes: "Types de services offerts",
    serviceRegions: "Régions desservies",
    sectors: "Secteurs desservis",
    orgTypes: "Types d'organisations desservies",
    favoritesOnly: "Mes favoris seulement",
    any: "Toutes les régions",
    clear: "Réinitialiser",
  },

  card: {
    viewProfile: "Voir le profil",
    favorite: "Ajouter aux favoris",
    unfavorite: "Retirer des favoris",
    website: "Site web",
    serves: "Régions desservies",
    regionUnknown: "Région non précisée",
    servesRegions_one: "{{count}} région desservie",
    servesRegions_other: "{{count}} régions desservies",
    moreRegions_one: "+{{count}} autre",
    moreRegions_other: "+{{count}} autres",
  },

  profile: {
    back: "Retour au répertoire",
    presentation: "Présentation",
    coveredIssues: "Enjeux couverts dans l'Activateur",
    overview: "Aperçu",
    contact: "Coordonnées",
    contactPerson: "Personne-ressource",
    contactCta: "Contacter cet expert",
    email: "Courriel",
    phone: "Téléphone",
    extension: "poste {{ext}}",
    website: "Site web",
    headOffice: "Siège social",
    region: "Région",
    address: "Adresse",
    originRegions: "Régions d'origine",
    servedRegions: "Régions desservies",
    serviceTypes: "Types de services offerts",
    sectors: "Secteurs desservis",
    orgTypes: "Types d'organisations desservies",
    founded: "Fondée en",
    ddStart: "Services en développement durable depuis",
    employees: "Nombre d'employés",
    dedicated: "Experts dédiés",
    awards: "Prix et distinctions",
    affiliations: "Ordre professionnel d'affiliation",
    expertises: "Domaines d'expertise",
    mandates: "Mandats de référence",
    mandateCount_one: "{{count}} mandat",
    mandateCount_other: "{{count}} mandats",
    goals: "Objectifs",
    noExpertises: "Aucun domaine d'expertise déclaré.",
    noMandates: "Aucun mandat de référence.",
    notAvailable: "Ce profil d'expert n'est pas disponible.",
  },

  favorites: {
    heading: "Experts enregistrés",
    help: "Les experts que vous avez enregistrés pour vos actions.",
    empty: "Vous n'avez enregistré aucun expert.",
    emptyHint:
      "Enregistrez des experts depuis le répertoire pour les comparer plus tard.",
    remove: "Retirer",
    removed: "Retiré des favoris",
    savedFor: "Enregistré pour une action",
  },

  dashboard: {
    heading: "Mon espace expert",
    notFound:
      "Vous n'avez pas encore de profil d'expert finalisé. Complétez l'inscription pour figurer au répertoire.",
    goToRegister: "Commencer l'inscription",
    profileEyebrow: "Mon profil en détail",
    viewPublic: "Voir mon profil public",
    completeProfile: "Sélectionner mes objectifs et actions",
    editObjectives: "Modifier mes objectifs",
    edit: "Modifier mon profil",
    editResubmit: "Corriger et resoumettre",
    editMenu: {
      info: "Mes informations",
      expertise: "Mes expertises",
      goals: "Mes objectifs",
    },
    lastStep: {
      title: "Dernière étape",
      body: "Votre inscription est approuvée. Sélectionnez vos objectifs et vos pistes d'action pour rendre votre profil visible dans le répertoire.",
      newIssueBody:
        "Votre nouvel enjeu est approuvé. Sélectionnez ses objectifs et pistes d'action pour les afficher dans le répertoire.",
    },
    lead: {
      submitted: "Votre demande est en cours d'analyse par le CQDD.",
      validated:
        "Votre profil est publié dans le répertoire d'experts de l'Activateur.",
      approved: "Votre inscription est approuvée.",
      validatedPending:
        "Vos modifications sont en attente de validation. Votre profil validé reste affiché entre-temps.",
      rejected: "Votre demande n'a pas été retenue par le CQDD.",
    },
    banner: {
      pendingLabel: "Modifications en attente",
      pendingBody:
        "Le CQDD examinera vos changements. Aucune action n'est requise de votre part.",
      rejectedLabel: "Message du CQDD",
    },
    stats: {
      enjeux: "Enjeux d'expertise",
      actions: "Pistes d'action",
      regions: "Régions desservies",
      mandates: "Mandats de référence",
    },
    status: {
      label: "Statut",
      draft: "Brouillon",
      submitted: "Soumis",
      validated: "Validé",
      rejected: "Refusé",
    },
    detail: {
      identity: "Identité et coordonnées",
      org: "Profil de l'organisation",
      scope: "Portée de service",
      expertises: "Expertises, pistes d'action et mandats",
      legalName: "Nom au REQ",
      neq: "NEQ",
      email: "Courriel",
      phone: "Téléphone",
      website: "Site web",
      headOffice: "Siège social",
      otherLocations: "Autres places d'affaires",
      otherProvinces: "Autres provinces et territoires",
      primaryContact: "Répondant principal",
      secondaryContact: "Répondant secondaire",
      foundingYear: "Année de fondation",
      ddStart: "Début des services DD",
      employees: "Nombre d'employés",
      dedicated: "Experts dédiés au DD",
      awards: "Prix et distinctions",
      affiliations: "Ordre professionnel d'affiliation",
      regions: "Régions desservies",
      sectors: "Secteurs desservis",
      types: "Types d'organisations",
      objectives: "Objectifs et pistes d'action",
      noActions: "Aucune piste d'action sélectionnée",
      mandate: "Mandat de référence",
      preapproved: "Préapprouvé par le CQDD",
      clients: "Coordonnées du client",
      noName: "Client sans nom",
      mandateCount_one: "{{count}} mandat réalisé",
      mandateCount_other: "{{count}} mandats réalisés",
      noExpertise: "Aucune expertise déclarée.",
      enjeuxCount_one: "{{count}} enjeu",
      enjeuxCount_other: "{{count}} enjeux",
      none: "—",
    },
  },

  objectives: {
    heading: "Objectifs et pistes d'action",
    help: "Votre inscription est approuvée. Pour chaque enjeu déclaré, choisissez les objectifs pour lesquels vous offrez des services et les pistes d'action auxquelles vous pouvez contribuer. Cela complète votre profil et le rend visible dans le répertoire.",
    backToDashboard: "Retour au tableau de bord",
  },

  register: {
    heading: "Devenir un expert répertorié",
    help: "Inscrivez votre organisation pour figurer au répertoire des experts en développement durable. Vos réponses sont enregistrées à chaque étape.",
    loadError: "Impossible de charger votre inscription. Réessayez plus tard.",
    submittedTitle: "Votre demande a été soumise",
    submittedLead: "Votre demande sera analysée par le CQDD.",
    submittedNote:
      "Le CQDD pourrait communiquer avec vous pour obtenir des informations complémentaires. Si votre demande est approuvée, vous recevrez un courriel vous permettant de sélectionner vos objectifs et pistes d'action pour aider les PME utilisatrices de l'Activateur.",
    goToDashboard: "Accéder à mon tableau de bord",
    save: "Enregistrer",
    saveChanges: "Enregistrer les modifications",
    stepLabel: "Étape {{current}} sur {{total}}",
    steps: {
      org: "Organisation",
      serviceRange: "Portée des services",
      expertise: "Expertise",
      goals: "Objectifs et actions",
    },
    next: "Suivant",
    back: "Précédent",
    submit: "Terminer et soumettre",
    submitRequest: "Soumettre ma demande",
    declarationTitle: "Validation et déclaration",
    confirmSubmit: "Confirmer et soumettre",
    confirmSave: "Confirmer et enregistrer",
    cancel: "Annuler",
    orgOverviewHeading: "Présentation générale de l'organisation",
    expertiseHeading: "Expertise — enjeux de durabilité",
    locationHeading: "Localisation",
    otherPlacesHeading: "Autres places d'affaires",
    otherPlacesHelp:
      "Ajoutez chaque autre place d'affaires de votre organisation, avec son adresse, sa région et sa MRC. Laissez vide si vous n'en avez pas.",
    addPlace: "Ajouter une place d'affaires",
    removePlace: "Retirer cette place d'affaires",
    chooseRegion: "Choisissez une région",
    chooseMrc: "Choisissez une MRC",
    mandatoryNote: "Tous les champs avec un * sont obligatoires.",
    actionsModalIntro:
      "Sélectionnez les actions auxquelles vous pouvez contribuer pour cet objectif.",
    eligibilityHeading: "Admissibilité",
    organizationContactHeading: "Coordonnées de l'organisation",
    contactsHeading: "Personnes-contacts",
    contactHeading: "Répondant principal",
    contactHeadingSecondary: "Répondant secondaire",
    contact: {
      last_name: "Nom",
      first_name: "Prénom",
      function: "Fonction",
      email: "Courriel",
      phone: "Téléphone professionnel",
      extension: "Poste",
      linkedin: "Profil LinkedIn",
    },
    profileHeading: "Description de l'organisation",
    scopeHeading: "Portée des services",
    // Still read by the tool and financial-aid admin forms, which keep sizes.
    selectAllSizes: "Toutes les tailles",
    scopeIntro: "Indiquez les régions, secteurs et types d'organisations que vous desservez.",
    scopeHelp:
      "Ces choix définissent les options offertes pour chaque enjeu à l'étape suivante.",
    expertiseHelp:
      "Sélectionnez les enjeux pour lesquels vous offrez une expertise. Pour chaque enjeu, décrivez un mandat de référence et précisez la portée.",
    profileCompleted:
      "Votre profil est complété : vos objectifs et pistes d'action sont maintenant visibles dans le répertoire.",
    pendingIssuesNotice:
      "Les objectifs et pistes d'action de vos nouveaux enjeux vous seront proposés une fois vos modifications approuvées par le CQDD.",
    goalsHelp:
      "Pour chaque enjeu, choisissez les objectifs visés et les pistes d'action correspondantes.",
    mandateHeading: "Mandat de référence",
    signatureStatement:
      "Je confirme l'exactitude de cette déclaration (signature électronique).",
    preapproved: "Préapprouvé par le CQDD",
    preapprovedNoMandate:
      "Aucun mandat à décrire pour cet enjeu : le CQDD a déjà reconnu votre expertise. Votre inscription reste soumise à la validation du CQDD.",
    preapprovedNoticeTitle: "Enjeux préapprouvés",
    preapprovedNotice:
      "Le CQDD a préapprouvé votre expertise pour : {{names}}. Pour ces enjeux, aucun mandat n'est demandé. Pour tout autre enjeu que vous ajoutez, décrivez un mandat réalisé. L'ensemble de votre demande sera analysé par le CQDD.",
    noObjectives: "Aucun objectif disponible pour cet enjeu.",
    noActions: "Aucune action n'est rattachée à cet objectif.",
    addClient: "Ajouter un client",
    clientsConfidential:
      "Informations à l'usage exclusif du CQDD qui ne seront pas rendues publiques. Un client pourrait être contacté pour valider qu'elles sont véridiques.",
    removeClient: "Retirer ce client",
    describeMandate: "Décrire le mandat",
    editMandate: "Modifier",
    mandateModalTitle: "Mandat",
    mandateHelp:
      "Veuillez indiquer le nombre de mandats réalisés pour cet enjeu. Un seul suffit pour vous qualifier.",
    mandateDescriptionHelp:
      "Veuillez décrire un mandat illustrant votre expertise spécifique à cet enjeu.",
    mandateIncomplete: "À compléter",
    mandateUnnamed: "Mandat sans titre",
    actionsLabel: "Actions",
    actionsModalTitle: "Actions",
    done: "Terminé",
    selectedCount_one: "{{count}} sélectionné",
    selectedCount_other: "{{count}} sélectionnés",
    select: "Sélectionner",
    modify: "Modifier",
    noSelection: "Aucune sélection",
    noneSelected: "Aucune option sélectionnée",
    selectAll: "Tout sélectionner",
    selectAllIn: "Tout sélectionner — {{name}}",
    // Badge the closed control collapses a fully picked group to.
    allOfGroup: "Tout {{name}}",
    search: "Rechercher…",
    searchIn: "Rechercher dans {{name}}",
    noSearchResult: "Aucun résultat",
    selectAllRegions: "Toutes les régions",
    selectAllSectors: "Tous les secteurs",
    selectAllTypes: "Tous les types",
    refineScope: "Préciser la portée pour cet enjeu (si différente de l'inscription)",
    scopeForIssue: "Portée pour cet enjeu",
    uncategorized: "Autres",
    otherSectors: "Autre(s) secteur(s)",
    otherTypes: "Autre(s) type(s)",
    otherServices: "Autre(s) type(s) de services",
    fields: {
      organization_name: "Nom de l'organisation",
      legal_name_req: "Nom au Registre des entreprises du Québec (REQ)",
      neq: "Numéro d'entreprise du Québec (NEQ)",
      website: "Site web",
      email: "Courriel de l'organisation",
      phone: "Téléphone de l'organisation",
      head_office_address: "L'adresse de votre siège social",
      head_office_region: "Région administrative du siège social",
      head_office_mrc: "MRC du siège social",
      place_address: "Adresse de la place d'affaires",
      place_region: "Région administrative de la place d'affaires",
      place_mrc: "MRC de la place d'affaires",
      serves_other_provinces:
        "Offrez-vous des services dans d'autres provinces et territoires canadiens ?",
      other_provinces: "Si oui, précisez",
      on_rena:
        "Votre organisation figure-t-elle sur le Registre des entreprises non admissibles aux contrats publics (RENA) ?",
      contact_primary_first_name: "Prénom",
      contact_primary_last_name: "Nom",
      contact_primary_function: "Fonction",
      contact_primary_email: "Courriel du contact",
      contact_primary_phone: "Téléphone du contact",
      founding_year: "Année de fondation",
      dd_services_start_year:
        "Début des services en développement durable (année)",
      total_employees: "Nombre total d'employés",
      dedicated_experts_count:
        "Nombre d'experts dédiés à l'offre de service en développement durable",
      description: "Description de l'organisation (1 000 caractères max., espaces compris)",
      awards: "Prix et distinctions",
      affiliations: "Ordre professionnel d'affiliation, si applicable ?",
      service_types: "Quels types de services offrez-vous ?",
      service_regions: "Régions desservies",
      sectors_served: "Secteurs d'activité desservis",
      organization_types_served: "Types d'organisations desservies",
      mandate_name: "Titre du mandat",
      mandate_year: "Année de réalisation",
      mandate_description:
        "Brève description du mandat : Décrivez l'objectif principal, les étapes de réalisation et les livrables (1 000 caractères max., espaces compris).",
      mandate_accompaniment:
        "Ce mandat constitue un mandat d'accompagnement (et non de vente de produit/logiciel)",
      mandate_count: "Nombre de mandats réalisés pour cet enjeu",
      mandate_clients: "Coordonnées du client",
      client_org_name: "Nom de l'organisation",
      client_contact_name: "Personne contact",
      client_phone: "Téléphone professionnel",
      client_email: "Courriel du client",
      issue_sectors: "Secteurs pour cet enjeu",
      issue_org_types: "Types d'organisations pour cet enjeu",
      consent_display:
        "Je consens à ce que le CQDD analyse ma demande pour confirmer mon admissibilité au répertoire d'expert.",
      declarant_name: "Nom",
      declarant_function: "Fonction",
    },
    yes: "Oui",
    no: "Non",
    validation: {
      organization_name: "Le nom de l'organisation est requis.",
      no_enjeu: "Sélectionnez au moins un enjeu.",
      contact_email: "Entrez un courriel valide.",
      required: "Ce champ est obligatoire.",
      too_long: "Ce texte ne peut pas dépasser {{limit}} caractères (espaces compris).",
      mrc_region: "Cette MRC n'appartient pas à la région choisie.",
      place_region_required: "Choisissez la région de cette place d'affaires.",
      mrc_required: "Choisissez la MRC de cette place d'affaires.",
      place_mrc_region:
        "Cette MRC n'appartient pas à la région de cette place d'affaires.",
      goal_needs_action: "Sélectionnez au moins une action pour cet objectif.",
      provinces_required: "Choisissez au moins une province ou un territoire.",
      fix_required: "Veuillez remplir tous les champs obligatoires.",
      fix_indicated: "Veuillez corriger les champs indiqués.",
      rena_ineligible:
        "Une organisation inscrite au RENA n'est pas admissible au répertoire d'experts.",
      mandate_name: "Le titre du mandat est requis.",
      mandate_year: "L'année de réalisation est requise.",
      mandate_year_range: "Veuillez indiquer une année entre {{min}} et {{max}}.",
      mandate_description: "La description du mandat est requise.",
      mandate_accompaniment: "La confirmation est requise.",
      client_email: "L'adresse courriel est invalide.",
      client_phone: "Le numéro de téléphone est invalide.",
      phone: "Le numéro de téléphone est invalide.",
    },
  },

  invite: {
    title: "Invitation au Répertoire d'experts",
    validBody:
      "Votre invitation est valide. Créez votre compte pour compléter votre inscription au répertoire.",
    cta: "Créer mon compte",
    toLogin: "J'ai déjà un compte — se connecter",
    invalid: "Ce lien d'invitation n'est pas valide.",
    revoked: "Ce lien d'invitation n'est plus valide.",
    expired: "Ce lien d'invitation a expiré.",
    used: "Cette invitation a déjà été utilisée. Veuillez vous connecter.",
  },

  signup: {
    title: "Créer un compte expert",
    subtitle:
      "Créez votre compte pour vous inscrire au Répertoire d'experts Activateur.",
    password: "Mot de passe",
    passwordConfirm: "Confirmer le mot de passe",
    submit: "Créer mon compte",
  },

  emailConfirmation: {
    title: "Validation de l'inscription",
    body: "Votre compte a été créé, mais vous devez maintenant le valider en cliquant le lien contenu dans le courriel que nous venons de vous envoyer à l'adresse spécifiée précédemment.",
    spamNote:
      "La réception du courriel de confirmation peut prendre plusieurs minutes et aboutir dans votre dossier de courriels indésirables.",
    check: "Vérifier si mon courriel est confirmé",
    checking: "Vérification…",
    pending:
      "Votre courriel n'est pas encore confirmé. Veuillez vérifier votre boîte de réception.",
  },

  admin: {
    title: "Gestion des experts",
    filtersHeading: "Filtres",
    search: "Organisation, courriel, NEQ…",
    allStatuses: "Tous les statuts",
    view: "Voir",
    pendingChanges: "Modifications en attente",
    empty: "Aucun expert.",
    countTotal_one: "{{count}} expert au total",
    countTotal_other: "{{count}} experts au total",
    countMatch_one: "{{count}} expert correspond aux filtres",
    countMatch_other: "{{count}} experts correspondent aux filtres",
    noName: "(sans nom)",
    filterRegion: "Région",
    filterProvenance: "Provenance",
    filterIssue: "Enjeu",
    allRegions: "Toutes les régions",
    allProvenances: "Toutes les provenances",
    allIssues: "Tous les enjeux",
    filter: "Filtrer",
    reset: "Réinitialiser",
    exportFiltered: "Exporter les résultats filtrés",
    exportAll: "Exporter tous les experts",
    confirmRevoke: "Confirmer la révocation de cette invitation ?",
    confirmBulkSend: "Envoyer maintenant toutes les invitations non envoyées ?",
    searchInvitation: "Rechercher une invitation",
    invSentAt: "Envoyée le",
    invExpiresAt: "Expire le",
    invAllStatuses: "Tous les statuts",
    invStatusUnsent: "Non envoyée",
    invStatusSent: "Envoyée",
    invStatusExpired: "Expirée",
    columns: {
      organization: "Organisation",
      email: "Courriel",
      status: "Statut",
      registered: "Inscrit le",
      lastLogin: "Dernière connexion",
      actionSelections: "Pistes d'action",
      actions: "Actions",
    },
    statuses: {
      draft: "Brouillon",
      submitted: "Soumis",
      validated: "Validé",
      rejected: "Refusé",
    },
    tabsLabel: "Sections du répertoire",
    tabs: {
      experts: "Experts",
      invitations: "Invitations en attente",
    },
    sendInvite: "Envoyer une invitation",
    inviteEmail: "Courriel",
    inviteContactName: "Nom de la personne invitée",
    language: "Langue de l'invitation",
    send: "Envoyer",
    sendInviteSubmit: "Envoyer l'invitation",
    inviteSent: "Invitation envoyée à {{email}}.",
    resend: "Renvoyer",
    revoke: "Révoquer",
    sendPending: "Envoyer les invitations non envoyées ({{count}})",
    invitationEmpty: "Aucune invitation en attente.",
    exportButton: "Exporter (.xlsx)",
    importExperts: "Importer des experts",
    importIssues: "Importer les enjeux",
    import: {
      pick: "Choisir un fichier .xlsx",
      downloadTemplate: "Télécharger le modèle",
      preview: "Aperçu (aucune donnée enregistrée)",
      confirm: "Confirmer l'import",
      totalRows: "Lignes lues",
      created: "À créer",
      updated: "À mettre à jour",
      skipped: "Ignorées",
      expertsMatched: "Experts concernés",
      pairsApplied: "Enjeux préapprouvés",
      errors: "En erreur",
      applied: "Import terminé.",
      downloadErrors: "Télécharger les lignes en erreur",
      rowLabel: "Ligne",
      errorColumn: "Erreur",
      noteColumn: "Précision",
      notOffered: "Préapprouvés, masqués à l'inscription",
      notOfferedHeading_one:
        "{{count}} enjeu est préapprouvé et conservé, mais n'est pas proposé à l'inscription",
      notOfferedHeading_other:
        "{{count}} enjeux sont préapprouvés et conservés, mais ne sont pas proposés à l'inscription",
      chooseAnother: "Choisir un autre fichier",
      duplicates_one: "{{count}} doublon identique ignoré (ligne fusionnée).",
      duplicates_other: "{{count}} doublons identiques ignorés (lignes fusionnées).",
      errorsHeading_one: "{{count}} ligne en erreur ne sera pas importée",
      errorsHeading_other: "{{count}} lignes en erreur ne seront pas importées",
    },
    history: {
      heading: "Historique",
      empty: "Aucun événement enregistré.",
      submission: "Demande soumise",
      changesSubmitted: "Modifications soumises",
      validated: "Demande validée",
      rejected: "Demande refusée",
      changesValidated: "Modifications validées",
      changesRejected: "Modifications refusées",
      declarant: "déclarant : {{name}}",
      by: "par {{name}}",
    },
    detail: {
      back: "Retour à la liste",
      list: "Liste",
      eligibility: "Admissibilité",
      onRena: "Inscrit au RENA",
      renaListed: "Inscrite au RENA",
      renaListedHint: "Non admissible au répertoire",
      renaNotListed: "Non inscrite au RENA",
      renaNotListedHint: "Aucun empêchement",
      renaUnknown: "Inscription au RENA",
      renaUnknownHint: "Non renseignée",
      completeness: "Complétude du profil",
      completenessMissing: "{{count}} champ(s) manquant(s)",
      missing: "Champs manquants",
      declarationHeading: "Déclaration et provenance",
      declarant: "Déclarant",
      declarationDate: "Date de déclaration",
      signatureConsent: "Signature / consentement",
      signatureConfirmed: "Signature confirmée",
      consentDisplay: "Consentement à l'analyse",
      noConsent: "Sans consentement",
      invitedBy: "Invité par",
      neq: "NEQ",
      submittedAgo: "Soumis il y a {{ago}}",
      submittedOn: "Soumis le {{date}}",
      reviewedBy: "par {{who}}",
      enjeux: "Enjeux et expertises",
      preapproved: "Préapprouvé par le CQDD",
      hiddenPreapproved: "Préapprouvés, non proposés à l'inscription",
      hiddenPreapprovedHelp:
        "La préapprobation est conservée, mais l'enjeu n'apparaît pas sur le formulaire de l'expert : sa thématique n'autorise pas les experts, ou aucune de ses pistes d'action ne leur est ouverte.",
      isNew: "Nouveau",
      mandateChanged: "Mis à jour",
      mandate: "Mandat de référence",
      mandateYear: "Réalisé en {{year}}",
      mandateCount_one: "{{count}} mandat réalisé",
      mandateCount_other: "{{count}} mandats réalisés",
      objectives: "Objectifs et pistes d'action",
      clients: "Coordonnées du client",
      clientNoName: "Client sans nom",
      removed: "Retiré par l'expert",
      outsideSectors: "Hors secteurs desservis",
      outsideSectorsNote:
        "Hors secteurs desservis, non visible pour l'expert ou les entreprises",
      orphans: "Autres (enjeu non déclaré)",
      identityHeading: "Identité et coordonnées",
      profileHeading: "Profil de l'organisation",
      scope: "Portée de service",
      noEnjeux: "Aucune expertise déclarée.",
      validate: "Valider la demande",
      validateChanges: "Valider les modifications",
      reject: "Refuser la demande",
      rejectChanges: "Refuser les modifications",
      rejectMessageLabel:
        "Message envoyé à l'expert (inclus dans le courriel de refus). Facultatif.",
      cancel: "Annuler",
      remind: "Relancer",
      revalidate: "Revalider",
      reminderSent: "Un rappel a été envoyé à {{name}}.",
      reminderError: "Le rappel n'a pas pu être envoyé.",
      decisionDone: "Décision enregistrée.",
      decisionError: "La décision n'a pas pu être enregistrée.",
      notes: {
        title: "Notes internes",
        private: "Non visible par l'expert",
        addLabel: "Ajouter une note (usage interne uniquement).",
        add: "Ajouter la note",
        empty: "Aucune note interne pour le moment.",
        unknownAuthor: "Auteur inconnu",
        seeAll: "Voir toutes les notes ({{count}})",
        delete: "Supprimer la note",
        error: "La note n'a pas pu être enregistrée.",
      },
    },
  },

  invitations: {
    heading: "Invitations d'experts",
    help: "Invitations à revendiquer un profil d'expert (administration CQDD).",
    empty: "Aucune invitation.",
    columns: {
      email: "Courriel",
      source: "Provenance",
      status: "Statut",
      created: "Créée le",
      expires: "Expire le",
    },
    source: {
      invitation: "Invitation",
      import: "Importation",
      self_registration: "Auto-inscription",
    },
    status: {
      revoked: "Révoquée",
      used: "Acceptée",
      expired: "Expirée",
      sent: "Envoyée",
      unsent: "Non envoyée",
      pending: "Non envoyée",
    },
  },
} as const;
